import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FinesService } from '../../service/main/fines.service';
import { PaginationService } from '../../service';
import { DateRange, Fine, Supervisor } from '../../entity';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';


@Component({
    selector: 'app-supervisor-fines',
    templateUrl: './supervisor-fines.component.html'
})
export class SupervisorFinesComponent implements OnInit {
    supervisor: Supervisor = new Supervisor();
    fines: Array<Fine> = new Array<Fine>();
    filteredList: Array<Fine> = new Array<Fine>();

    //#region component state properties
    loadingState = false;
    noRecordsState = true;
    //#endregion

    //#region date picker properties
    initialPickerDate: Date[];
    bsConfig: Partial<BsDaterangepickerConfig> = {
        rangeInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false
    };
    //#endregion

    //#region search & sort properties
    tags = new Array<string>();
    searchWord = '';
    //#endregion

    //#region pagination properties
    pagedItems: Array<Fine>;
    pager: any = {};
    //#endregion

    constructor(
        private route: ActivatedRoute,
        private finesService: FinesService,
        private paginationService: PaginationService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        this.route.queryParams.subscribe((params: Params) => {
            this.supervisor.FullName = params['name'];
            this.supervisor.PortalOperatorID = params['id'];
            this.onDateRangeChanged([new Date(), new Date()]);
        });
    }

    getFines(dateRange: DateRange) {
        this.loadingState = true;
        this.noRecordsState = false;

        this.finesService.getFinesBySupervisor(dateRange).subscribe(data => {
            const fines = new Array<Fine>();
            data.forEach(item => {
                const fine = new Fine();
                fine.fromObject(item);

                if (fine.Avatar == null) {
                    fine.Avatar = './../../assets/placeholder.jpg';
                }

                fines.push(fine);
            });

            this.fines = fines;
            this.filteredList = fines;
            this.setPage(1);
            this.loadingState = false;


            if (this.fines.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });
    }

    onDateRangeChanged(event: Date[]) {
        const dateRange = new DateRange(
            event[0],
            event[1],
            this.supervisor.PortalOperatorID
        );
        dateRange.StartDate.setHours(2);
        dateRange.StartDate.setMinutes(0);

        dateRange.EndDate.setHours(25);
        dateRange.EndDate.setMinutes(59);

        this.getFines(dateRange);
    }

    //#region pagination, search
    updateFilterTags(tags: Array<string>) {
        this.tags = tags;
        this.refreshFilteredList();
    }

    search(word?: string): void {
        this.searchWord = word;
        this.refreshFilteredList();
    }

    refreshFilteredList(): void {
        this.filteredList = this.fines;
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'Parking', this.tags);
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'Plate', [this.searchWord]);
        this.setPage(1);
    }

    setPage(page: number): void {
        this.pager = this.paginationService.getPager(this.filteredList.length, page, 6);
        this.pagedItems = this.filteredList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    //#endregion
}
